import { useShallow } from 'zustand/react/shallow';
import { startTransition, useCallback, useEffect, useState } from 'react';
import { useMapVisibilityStore } from '@pkgs/components/providers/MapVisibilityStoreProvider';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { Map as MapIcon } from '@pkgs/components/assets/icons/small/Map';
import ListViewIcon from '@pkgs/components/assets/icons/small/ListView.svg';
import { Button } from '@ev-tech/ui-core-components/Button';

import styles from './SearchResults.module.css';

export const MapViewButton = () => {
  const { t } = useAppContext();
  const { featureFlags } = useAppContext();
  const { isMapActiveState, hasMounted, isWebGLEnabled, updateIsMapView } = useMapVisibilityStore(
    useShallow((state) => ({
      isMapActiveState: state.isMapActive,
      hasMounted: state.hasMounted,
      isWebGLEnabled: state.isWebGLEnabled,
      updateIsMapView: state.actions.updateIsMapView,
    })),
  );
  const [isMapActive, setMapActive] = useState(isMapActiveState);

  useEffect(() => {
    setMapActive(isMapActiveState);
  }, [isMapActiveState]);

  const handleClick = useCallback(() => {
    const nextMapView = !isMapActive;
    setMapActive(nextMapView);
    startTransition(() => updateIsMapView(nextMapView));
  }, [isMapActive, updateIsMapView]);

  if (!featureFlags.isMapEnabled || !hasMounted || !isWebGLEnabled) return null;

  return (
    <Button
      className={styles.mapViewButton}
      icon={isMapActive ? <ListViewIcon /> : <MapIcon />}
      label={isMapActive ? t('search.searchResults.floatingButton.label.list') : t('search.searchResults.floatingButton.label.map')}
      variant="tertiary"
      onClick={handleClick}
      testId="search-components_map-view-toggle-button"
    />
  );
};
